module.exports = __webpack_public_path__ + "img/logo.b2ecddd1.png";